import React from 'react';
import PropTypes from 'prop-types';
import TopNavigation from '../../components/Navigation/TopNavigation';
// import AdFooter from '../../components/AdFooter/AdFooter';
// import SuuntoFooter from '../../components/Footer/SuuntoFooter';

// eslint-disable-next-line
export default function PageLayout({ noAdBanner, children, contentOnly }) {
  return (
    <div className="page-container is-relative">
      { !contentOnly && <TopNavigation links={__BRAND__.topNavigationLinks} /> }
      {children}
      {/*! noAdBanner && __BRAND__.name === 'suunto' && <AdFooter /> */}
      {/* __BRAND__.name === 'suunto' && <SuuntoFooter showLinks={!contentOnly} /> */}
    </div>
  );
}

PageLayout.propTypes = {
  noAdBanner: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
  contentOnly: PropTypes.bool.isRequired,
};
